import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';

const colors = new Colors();

const DurationIndicator = ({plocked, slice, on, color, transpose, stepData, duration, velocity}) => { 
    if (!on) {
        return '';
    }
    let width = duration * 32.5;
    let style = {
        width,
        backgroundColor: color,
        opacity: velocity,
        top: (-15 - (transpose * 0.25)) + 'px'
    };

    let className = "duration-indicator";
    if (slice) {
        //className += " sliced";
        let selectedSliceColor = colors.getColor(slice);
        style.backgroundColor = selectedSliceColor;
    }
    return (
        <div style={style} className={className}>
        </div>);
}

const mapStateToProps = (state, props) => {
    if (!props.stepData || !props.stepData.durationParameter || !props.stepData.trackData) {
        return {};
    }
  return {
      on: props.stepData.on,
      duration: props.stepData.duration,
      transpose: props.stepData.transpose,
      velocity: props.stepData.velocity,
      slice: props.stepData.slice,
      plocked: props.stepData.pLockedParameters.length 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DurationIndicator);
